/**
 * @generated SignedSource<<2ff97e9b16bd5fb5ceb9cc9d270a2e55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_user">;
  readonly " $fragmentType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$key = {
  readonly " $data"?: PdpRespShippingReturns_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b45d1a2d61b95a025241644cebf4ce23";

export default node;
